<svg
    width="340"
    height="187"
    viewBox="0 0 340 187"
    xmlns="http://www.w3.org/2000/svg">
    <g
        app-roof
        [type]="type()"></g>

    <g
        [width]="300"
        [height]="300"
        [x]="-30"
        [y]="-20"
        app-roof-box></g>


        <g
        [width]="300"
        [height]="300"
        [x]="30"
        [y]="-60"
        app-roof-box></g>


</svg>